import React from "react";
import { useSelector } from "react-redux";
import {
  InformationContainer,
  InformationDiv,
  InformationHeading,
  MainContainer,
  ProfileDiv,
} from "../Profile/Profile.style";

const SponsorDetails = () => {
  const sponsorData = useSelector((state) => state.Modal.val);
  return (
    <ProfileDiv>
      <MainContainer>
        <InformationContainer>
          <InformationHeading>Sponsor Name:</InformationHeading>
          <InformationDiv>{sponsorData.sponsor_name}</InformationDiv>
        </InformationContainer>
        <InformationContainer>
          <InformationHeading>Sponsor Id :</InformationHeading>
          <InformationDiv>{sponsorData.sponsor_id}</InformationDiv>
        </InformationContainer>
        <InformationContainer>
          <InformationHeading>Sponsor phone No :</InformationHeading>
          <InformationDiv>{sponsorData.spon_phone}</InformationDiv>
        </InformationContainer>
      </MainContainer>

      <MainContainer>
        <InformationContainer>
          <InformationHeading>Sponsor Email:</InformationHeading>
          <InformationDiv>{sponsorData.spon_email}</InformationDiv>
        </InformationContainer>

        <InformationContainer>
          <InformationHeading>Contact Person:</InformationHeading>
          <InformationDiv>{sponsorData.cont_person_nm}</InformationDiv>
        </InformationContainer>
        <InformationContainer>
          <InformationHeading>Contact Person Phone No.:</InformationHeading>
          <InformationDiv>{sponsorData.cont_person_ph}</InformationDiv>
        </InformationContainer>
      </MainContainer>

      <MainContainer>
        <InformationContainer>
          <InformationHeading>Sponsor Address :</InformationHeading>
          <InformationDiv>{sponsorData.spon_address}</InformationDiv>
        </InformationContainer>
      </MainContainer>
    </ProfileDiv>
  );
};

export default SponsorDetails;
